import extend from "extend";
import axios from "axios";
import config from "../config";
import i18n from '@/main';

const state = {
    profile: '',
    favicon: '',
    liveAppUrl: "about:blank",
    ugcAppUrl: "about:blank",
    livePageTabNameMaxWidth: 4,
    title: '',
    defaultLogo: true,
    lang: '',        //显示语言
    adminCenter: false,      //管理员中心入口
    liveSource_file: true,      //直播源文件类型
    materialPublish: true,       //素材管理素材发布
    videoBitrate_1920x1080: 3000,
    hlsTokenValidSpanSec: null,
    hlsTokenValidMinutes: null,
    materialCms: true,
    exit: true,
	goods: false,
    liveOnlineStat: null,
    vrDirector: false,
    vrEditor: false,
    liveRoomPreviewAutoPlay: null,
    uploadVideoLimit: null,
    uploadAudioLimit: null,
    uploadImageLimit: null,
    functionControlFullscreen: null,
	outerChain: false, // 气泡按钮
	extendBubble: null, // 相关报道气泡，开了这个气泡按就变为相关报道按钮了
    danmu: null,
    platformTitle: null,
    platformIcon: null,
	platformTitleColor: null,
	pushTranscode: false,
    initSelectType: 1
};

const getters = {};

const actions = {
    async load({
        commit,
    }) {
        try {
            // eslint-disable-next-line no-undef
            let ret = await axios.get("./profile.html?" + BUILD_VERSION, {
                ts: Date.now()
            });
            let data = ret.data;

            if (config.release && data.profile) {
                extend(data, data[data.profile] || {});
            }

            if (data.favicon) {
                [...document.querySelectorAll('link[rel*=icon]')].forEach(link => {
                    link.href = data.favicon;
                });
            }
            i18n.locale = data.lang;
            if (data.title) {
                document.title = i18n.t(data.title);
            }

            commit("setConfig", data);
        } catch (error) {
            console.log('加载配置失败', error);
        }
        return null;
    }
};

const mutations = {
    setConfig(state, data) {
        extend(state, data);
        // state.initSelectType = (data.profile=='nfplus'?3:1);
        // console.log("config profile:"+data.profile);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}